<template>
    <DFabs>
        <slot name="additional_buttons" />
    </DFabs>
</template>

<script>
export default {
    name: 'DAdditionalButtons',
    emits: ['assign', 'save'],
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    }
}
</script>

<style scoped>

</style>
